// Sample data for KW 27 (current week from the screenshot)
export const mockWeeklyData = [
    {
        weekNumber: 27,
        year: 2025,
        days: {
            monday: {
                dayNumber: 30, // 30. Juni
                menus: [
                    {
                        "@id": "/v1/dish-plan-items/1",
                        id: 1,
                        title: "Gemüsecurry mit Kokosmilch",
                        label: "vegetarian",
                        isSelected: false,
                        position: 0,
                    },
                    {
                        "@id": "/v1/dish-plan-items/1",
                        id: 2,
                        title: "Gefüllte Paprika",
                        label: "vegetarian",
                        isSelected: true,
                        position: 1,
                    },
                    {
                        "@id": "/v1/dish-plan-items/1",
                        id: 3,
                        title: "Mediterrane Gemüsepfanne",
                        label: "vegetarian",
                        isSelected: false,
                        position: 2,
                    },
                ],
                desserts: ["Obstbecher", "Salatbuffet"],
            },
            tuesday: {
                dayNumber: 1,
                isSchoolHoliday: true,
                menus: [
                    {
                        "@id": "/v1/dish-plan-items/1",
                        id: 4,
                        title: "Spaghetti Bolognese",
                        label: "meat",
                        isSelected: true,
                        position: 0,
                    },
                    {
                        "@id": "/v1/dish-plan-items/1",
                        id: 5,
                        title: "Hähnchenschnitzel",
                        label: "meat",
                        isSelected: false,
                        position: 1,
                    },
                    {
                        id: 6,
                        "@id": "/v1/dish-plan-items/1",
                        title: "Vegetarische Lasagne",
                        label: "vegetarian",
                        isSelected: false,
                        position: 2,
                    },
                ],
                desserts: ["Joghurt mit Früchten", "Rohkostsalat"],
            },
            wednesday: {
                dayNumber: 2,
                menus: [
                    {
                        id: 7,
                        title: "Fischfilet gebraten",
                        label: "fish",
                        isSelected: true,
                        "@id": "/v1/dish-plan-items/1",
                        position: 0,
                    },
                    {
                        id: 8,
                        title: "Gemüsepfanne asiatisch",
                        label: "vegetarian",
                        isSelected: false,
                        "@id": "/v1/dish-plan-items/1",
                        position: 1,
                    },
                    {
                        id: 9,
                        title: "Linsenbratlinge",
                        label: "vegetarian",
                        isSelected: false,
                        "@id": "/v1/dish-plan-items/1",
                        position: 2,
                    },
                ],
                desserts: ["Pudding", "Gemischter Salat"],
            },
            thursday: {
                dayNumber: 3,
                menus: [
                    {
                        id: 10,
                        title: "Kürbis-Risotto",
                        label: "vegetarian",
                        "@id": "/v1/dish-plan-items/1",
                        isSelected: true,
                        position: 0,
                    },
                    {
                        id: 11,
                        title: "Grünkern-Bratlinge",
                        label: "vegetarian",
                        "@id": "/v1/dish-plan-items/1",
                        isSelected: false,
                        position: 1,
                    },
                    {
                        id: 12,
                        title: "Gemüse-Tajine",
                        label: "vegetarian",
                        "@id": "/v1/dish-plan-items/1",
                        isSelected: false,
                        position: 2,
                    },
                ],
                desserts: ["Apfelkompott", "Blattsalate"],
            },
            friday: {
                dayNumber: 4,
                menus: [
                    {
                        id: 13,
                        title: "Pizza Margherita",
                        label: "vegetarian",
                        "@id": "/v1/dish-plan-items/1",
                        isSelected: true,
                        position: 0,
                    },
                    {
                        id: 14,
                        title: "Gemüse-Couscous",
                        label: "vegetarian",
                        "@id": "/v1/dish-plan-items/1",
                        isSelected: false,
                        position: 1,
                    },
                    {
                        id: 15,
                        title: "Ratatouille",
                        label: "vegetarian",
                        "@id": "/v1/dish-plan-items/1",
                        isSelected: false,
                        position: 2,
                    },
                ],
                desserts: ["Eis", "Karottensalat"],
            },
        },
    },
    {
        weekNumber: 28,
        year: 2025,
        days: {
            monday: {
                dayNumber: 7,
                menus: [
                    {
                        id: 16,
                        title: "Ratatouille",
                        label: "vegetarian",
                        "@id": "/v1/dish-plan-items/1",
                        isSelected: false,
                        position: 0,
                    },
                    {
                        id: 17,
                        title: "Quinoa-Salat",
                        "@id": "/v1/dish-plan-items/1",
                        label: "vegetarian",
                        isSelected: true,
                        position: 1,
                    },
                    {
                        id: 18,
                        "@id": "/v1/dish-plan-items/1",
                        title: "Gemüse-Risotto",
                        label: "vegetarian",
                        isSelected: false,
                        position: 2,
                    },
                ],
                desserts: ["Obstbecher", "Salatbuffet"],
            },
            tuesday: {
                dayNumber: 8,
                menus: [
                    {
                        id: 19,
                        title: "Paprika-Risotto",
                        "@id": "/v1/dish-plan-items/1",
                        label: "vegetarian",
                        isSelected: true,
                        position: 0,
                    },
                    {
                        id: 20,
                        title: "Zucchini-Puffer",
                        "@id": "/v1/dish-plan-items/1",
                        label: "vegetarian",
                        isSelected: false,
                        position: 1,
                    },
                    {
                        id: 21,
                        title: "Orientalische Linsensuppe",
                        "@id": "/v1/dish-plan-items/1",
                        label: "vegetarian",
                        isSelected: false,
                        position: 2,
                    },
                ],
                desserts: ["Joghurt", "Rohkost"],
            },
            wednesday: {
                dayNumber: 9,
                menus: [
                    {
                        id: 22,
                        "@id": "/v1/dish-plan-items/1",
                        title: "Lachsfilet",
                        label: "fish",
                        isSelected: false,
                        position: 0,
                    },
                    {
                        id: 23,
                        "@id": "/v1/dish-plan-items/1",
                        title: "Spinat-Ricotta-Gnocchi",
                        label: "vegetarian",
                        isSelected: true,
                        position: 1,
                    },
                    {
                        id: 24,
                        "@id": "/v1/dish-plan-items/1",
                        title: "Gemüse-Couscous",
                        label: "vegetarian",
                        isSelected: false,
                        position: 2,
                    },
                ],
                desserts: ["Mousse au Chocolat", "Blattsalat"],
            },
            thursday: {
                dayNumber: 10,
                type: "schoolClosed",
            },
            friday: {
                dayNumber: 11,
                type: "publicHoliday",
            },
        },
    },
];
//# sourceMappingURL=types.js.map